<template>
  <el-form label-width="100px">
    <el-form-item label="关联槽值：">
      <el-transfer
        ref="transfer"
        filterable
        filter-placeholder="请输入槽值"
        :props="{
          key: 'id',
          label: 'slot_name',
        }"
        :titles="['未关联', '已关联']"
        :value="combineSlot"
        :data="slotList"
        @change="handleChange"
      >
      </el-transfer>
    </el-form-item>
  </el-form>
</template>

<script>
  import { mapMutations, mapState } from 'vuex'
  export default {
    data() {
      return {
        filterMethod(query, item) {
          return item.slot_name.indexOf(query) > -1
        },
      }
    },
    mounted() {
      this.setTransfer(this.$refs.transfer)
    },
    computed: {
      ...mapState({
        slotList: (state) => state.aimManager.slotList,
        combineSlot: (state) => state.aimManager.combineSlot,
      }),
    },
    methods: {
      ...mapMutations('aimManager', ['setCombineSlot', 'setTransfer']),
      handleChange(e) {
        this.setCombineSlot(e)
      },
    },
  }
</script>

<style lang="scss">
  .el-transfer-panel {
    width: 218px;
  }
  .el-checkbox__label {
    width: 180px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
</style>
